import { types } from "../Actions/types";

const initialState = {
        registeredUserCount: 0,
        avgAge: 0,
        totalExerciseVideos: 0,
        totalPrograms: 0
};

const PlatformStats = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.PLATFORM_STATS:
      return {
        ...payload,
        error
      };
    default:
      return state;
  }
};

export default PlatformStats;
